import { render, staticRenderFns } from "./TrialItem.vue?vue&type=template&id=22490813&"
import script from "./TrialItem.vue?vue&type=script&lang=js&"
export * from "./TrialItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports